import {
  booleanAttribute,
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  Output,
} from '@angular/core';

import { FdkIconComponent } from '../icon/icon.component';
import { FdkIconButtonComponent } from '../icon-button/icon-button.component';

@Component({
  selector: 'fdk-header',
  imports: [FdkIconButtonComponent, FdkIconComponent],
  templateUrl: './header.component.html',
  styleUrl: './header.component.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
})
export class FdkHeaderComponent {
  private _logoUrl: string | null = null;

  @Input()
  get logoUrl(): string | null {
    return this._logoUrl;
  }

  set logoUrl(value: string | null) {
    this._logoUrl = value;
    this.logoIsWide = false;
  }

  @Input() logoAlt = '';
  @Input() name = '';
  @Input({ transform: booleanAttribute }) showBackButton = false;
  @Input({ transform: booleanAttribute }) showReportIssueButton = true;
  @Input({ transform: booleanAttribute }) showProfileButton = false;
  @Input({ transform: booleanAttribute }) showCloseButton = true;
  @Input({ transform: booleanAttribute }) testMode = false;
  @Input() testModeText = 'You are using Fasten in test mode';

  @Output() readonly back = new EventEmitter<void>();
  @Output() readonly reportIssue = new EventEmitter<void>();
  @Output() readonly profile = new EventEmitter<void>();
  @Output() readonly close = new EventEmitter<void>();

  logoIsWide = false;

  handleLogoLoad(event: Event): void {
    const logo = event.target as HTMLImageElement;
    console.log('Logo loaded:', logo.naturalWidth, logo.naturalHeight);
    this.logoIsWide = logo.naturalWidth > logo.naturalHeight;
  }

  handleLogoError(): void {
    this.logoIsWide = false;
  }
}
